import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router, { prefetchGuestPages } from './router'
import store from './store'
import './index.css'

import { swiffyslider } from 'swiffy-slider'
import 'swiffy-slider/css'

window.swiffyslider = swiffyslider
window.addEventListener('load', () => {
    window.swiffyslider.init()
})

// Смена языка перезагружает страницу (см. NavigatorNew.pick), поэтому
// грузим только словарь текущего языка, а не все 12 сразу.
const locales = import.meta.glob('./assets/i18n/*.json')

async function start() {
    const lang = localStorage.getItem('currentLang') || 'ru'
    const load = locales[`./assets/i18n/${lang}.json`] || locales['./assets/i18n/ru.json']
    const messages = (await load()).default

    // язык страницы для скринридеров и переносов; арабский пишется справа налево
    const htmlLang = { kz: 'kk', kg: 'ky', tj: 'tg', cn: 'zh' }[lang] || lang
    document.documentElement.lang = htmlLang
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'

    const i18n = createI18n({
        legacy: true,
        locale: lang,
        messages: { [lang]: messages },
    })

    createApp(App).use(store).use(router).use(i18n).mount('#app')
    if (location.pathname.split('/')[1]) prefetchGuestPages()
}

start()
